"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isRiderStatusLog = void 0;
var superstruct_1 = require("superstruct");
var isStruct_1 = require("../utils/isStruct");
var Timestamp_1 = require("./Timestamp");
/**
 * @deprecated use `RiderLogStruct` instead!
 */
var RiderStatusLogStruct = (0, superstruct_1.type)({
    createdAt: Timestamp_1.TimestampStruct,
    status: (0, superstruct_1.string)(),
    prevStatus: (0, superstruct_1.optional)((0, superstruct_1.string)()),
});
/**
 * @deprecated use `isRiderLog` instead!
 */
function isRiderStatusLog(obj) {
    return (0, isStruct_1.isStruct)(obj, RiderStatusLogStruct, "RiderStatusLog");
}
exports.isRiderStatusLog = isRiderStatusLog;
